import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../model/api-response-model';
import { VMS_USER_MASTER } from '../model/user-registration-model';
import { VendorModel } from '../model/vendor-model';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(private crudeSer:CrudService) { }

  SaveVendorRecord(model:VendorModel): Observable<ApiResponseModel>{
    return this.crudeSer.post<any>('Vendor/VendorMaster', model);
  }

  GetAllVendorMaster(): Observable<any> {
    return this.crudeSer.get('Vendor/GetAllVendors');
  } 
}
